<template>
    <ion-page>
        <SignedInHeader></SignedInHeader>
        <ion-content>
            <SwipeTransition>
                <router-view :key="$route.params.id"></router-view>
            </SwipeTransition>
        </ion-content>
        <ion-footer>
            <AddAlertProgress :progress="progress"></AddAlertProgress>
        </ion-footer>
    </ion-page>
</template>

<script>
    import AddAlertProgress from "@/components/AddAlertProgress";
    import SignedInHeader from "../components/SignedInHeader";
    import SwipeTransition from "../components/SwipeTransition";

    export default {
        name: 'add-alert',
        components: {
            SwipeTransition,
            SignedInHeader,
            AddAlertProgress
        },
        data() {
            return {
                progress: {step: 'to', value: '...'},
            }
        },
        mounted() {
            this.$AmplifyEventBus.$on('addAlertProgress', progress => {
                this.progress = progress;
            });
        }
    }
</script>

<style scoped>
    .ion-page {
        background: url('~@/assets/bg/bg10.jpg') no-repeat center center / cover;
    }

    ion-grid {
        height: 100%;
        font-family: 'Nunito', sans-serif;
    }

    ion-footer {
        background: rgba(255,255,255,.6);
        height: 3.8em;
    }

    ion-content >>> .swipable {
        position: absolute !important;
        width: 100%;
    }

    /*ion-footer ion-grid {
        --ion-grid-padding: 0;
        --ion-grid-columns: 15;
    }

    ion-footer ion-row {
    }

    ion-footer ion-col {
        --ion-grid-column-padding: 0;
    }

    ion-footer ion-col:first-of-type {
        padding-left: .5em;
    }

    ion-footer ion-col:last-of-type {
        padding-right: .5em;
    }

    ion-footer:hover {
        top: 0;
    }

    ion-footer ion-card {
        margin: 0;
    }

    ion-footer ion-item {
        --min-height: 2.5em;
        --background: none;
    }

    ion-footer ion-label {
        margin: auto 0;
        color: #666 !important;
        font-variant: small-caps;
    }

    ion-footer ion-card {
        margin: auto .25em !important;
        --background: rgba(255,255,255,.8) !important;
        padding: .25em;
    }

    ion-footer ion-icon {
        display: block;
        margin: 0;
        float: right;
    }

    .content-row ion-footer ion-item {
        padding: .25em;
    }*/

    ion-content >>> .content-row ion-grid {
        height: 100%;
        font-family: 'Nunito', sans-serif;
        --ion-grid-padding: 1em;
        padding-top: .5em;
    }

    ion-content >>> .content-row ion-input {
        margin-left: .5em;
    }

    ion-content >>> .content-row ion-item {
        --background: rgba(255,255,255,.6);
        --min-height: 1em;
    }

    ion-content >>> .content-row ion-button {
        margin-top: 1em;
    }

    ion-content >>> .content-row ion-label {
        font-family: 'Nunito', sans-serif;
    }

    ion-content >>> .content-row ion-card {
        --background: rgba(255,255,255,.8);
        font-family: 'Nunito', sans-serif;
    }

    ion-content >>> .content-row ion-card-title {
        --color: #333;
        font-size: 2em;
        font-weight: bold;
    }

    ion-content >>> .content-row ion-col {
        padding: 0;
    }

    ion-content >>> .content-row ion-thumbnail {
        height: 2.5em;
        width: 2.5em;
        margin: .3em .8em .3em 0em;
    }

    ion-content >>> .content-row ion-thumbnail ion-img {
        height: 2.5em;
        object-fit: contain;
    }
</style>